import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {ConditionType, PropertyTab} from 'common/widgets/cohorts-query-builder/models/enums/builder-enums';

import {FilterableClauseComponent} from '../filterable-clause-component';
import template from './index.jade';
import css from './index.styl?inline';

class CohortsCohortClause extends FilterableClauseComponent {
  shouldUpdate(state) {
    return super.shouldUpdate(state) && !!this.getClause(state).cohortId;
  }
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'user-id': {type: `number`, description: `ID of user viewing the builder`},
    };
  }

  get config() {
    return {
      ...super.config,
      useShadowDom: true,
      css,
      template,
      helpers: {
        ...super.config.helpers,
        getActionLabel: () => this.app.getActiveDataGroupLabel(),
        getActionOperatorLabel: () => (this.helpers.isNegated() ? `not in` : `in`),
        getResourceLabel: () => {
          const {cohort} = this;
          if (cohort) {
            return cohort.name;
          } else if (this.isLoadingCohorts()) {
            return `Loading...`;
          }
        },
        isResourceValid: () => !this.getClause().isDependentCohort,
        getInvalidResourceMessage: () => {
          return `Cannot use this cohort because it creates a cycle`;
        },
      },
    };
  }

  get conditionType() {
    return ConditionType.Cohorts;
  }

  get defaultPropertyFilterTab() {
    if (this.app.hasMultiplePeopleGroups()) {
      return PropertyTab.All;
    } else if (this.app.getDataGroupId()) {
      return PropertyTab.DataGroup;
    } else {
      return PropertyTab.People;
    }
  }

  getClause(state = this.state) {
    return state.stagedCohort.literals[this.literalIdx].clauses[this.clauseIdx];
  }

  isLoadingCohorts() {
    return this.state.loading.cohorts;
  }

  get cohort() {
    return this.app.getCohortById(this.getClause().cohortId);
  }
}

export const CohortsCohortClauseEl = defineAndMakeJsxFactory(`cohorts-cohort-clause`, CohortsCohortClause);
